import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { DatasourceContext } from '../gen2_widgets/base/DatasourceEngineGrid.jsx';

/**
 * Returns the filtered rows and cols for a widget's datasource.
 *
 * When the widget is wrapped in a DatasourceEngineGrid (all widgetWithDatasource widgets),
 * rows are pre-filtered by AG Grid's native filter engine via React context.
 *
 * @param {number} widgetId
 * @returns {{ rows: Array, cols: Array, datasourceId: number|null }}
 */

// Stable empty-array sentinels — an inline `?? []` inside a useSelector callback creates a new
// reference every render, so useSelector always sees a "changed" value and triggers an infinite
// render loop (see redux/datasourceSlice.js's EMPTY_ROWS/EMPTY_COLS for the same pattern).
const EMPTY_ROWS = [];
const EMPTY_COLS = [];

export const useDatasourceData = (widgetId) => {
  const ctx = useContext(DatasourceContext);

  // Always read legacy state (hooks must be called unconditionally)
  const legacyRows = useSelector(state => state.dashboard.widgets[widgetId]?.data_datasource?.rows) ?? EMPTY_ROWS;
  const legacyCols = useSelector(state => state.dashboard.widgets[widgetId]?.data_datasource?.cols) ?? EMPTY_COLS;
  const legacyDatasourceId = useSelector(
    state => state.dashboard.widgets[widgetId]?.data_datasource?.id
  );

  // Prefer context (centralized, AG Grid-filtered) when available
  if (ctx?.datasourceId != null) {
    return { rows: ctx.filteredRows, cols: ctx.cols, datasourceId: ctx.datasourceId };
  }

  console.warn("No datasource defined. Returning legacyRows")

  return { rows: legacyRows, cols: legacyCols, datasourceId: legacyDatasourceId };
};
